export enum UserVerificationPlatform {
  SumSub = 'sumsub',
}

export enum UserVerificationStatus {
  Approved = 'approved',
  Rejected = 'rejected',
  Pending = 'pending',
  InProgress = 'in-progress',
  NotRequired = 'not-required',
}

export interface VerificationData {
  status: UserVerificationStatus;
  applicantId?: string;
  updatedAt: Date;
  approvedAt?: Date;
  rejection?: string[];
  rejectionComment?: string;
  sumsubDob?: string;
}

export interface UserAgeResponse {
  age: number | null;
}

const blockedStatuses = [
  UserVerificationStatus.Rejected,
  UserVerificationStatus.Pending,
  UserVerificationStatus.InProgress,
];

export const isUserBlocked = (verificationData?: VerificationData) => {
  return verificationData && blockedStatuses.includes(verificationData?.status);
};
